const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const SESSION_KEY = "demo_session_id";

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export async function track(slug, event, screen, duration) {
  if (!slug) return;
  try {
    await fetch(`${BACKEND_URL}/api/demo/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        slug,
        event,
        screen: screen || null,
        duration_seconds: duration || null,
        session_id: getSessionId(),
        user_agent: navigator.userAgent,
      }),
    });
  } catch (e) {
    // Silent fail — never break the demo
  }
}

export function getSlug() {
  try {
    const path = window.location.pathname;
    const m = path.match(/^\/demo\/([^/]+)/);
    if (m) return m[1];
  } catch (e) {}
  return localStorage.getItem("demo_slug") || "";
}
